var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHorse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 43.158 46.1383",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0112 0H9.15571V3.02576C9.15571 5.23682 9.96295 7.39248 11.4104 9.13485L14.0113 6.74624V0L14.0112 0Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43.158 20.9312C43.158 15.3402 40.7874 10.0839 36.4828 6.13061C32.1781 2.17719 26.4549 0 20.3673 0H17.6232C21.1756 0.235114 23.9876 2.9646 23.9876 6.2861V6.50689C31.755 8.40122 37.2725 14.9102 37.2725 22.3909V46.1218H43.1579V20.9312H43.158Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.42842 27.3497L2.5758 29.0512C3.98645 29.7042 5.69578 29.6683 7.10672 28.8784L14.0142 25.0107H17.7101C20.6693 25.0107 23.0769 22.7996 23.0769 20.0818H26.0194C26.0194 24.1932 22.4612 27.5556 18.0243 27.7078V28.4744C18.0243 32.0935 16.5975 35.5884 14.0065 38.3152L13.7609 38.5738C11.7571 40.6826 10.603 43.3519 10.4795 46.1383H34.3301V22.3909C34.3301 15.8251 29.2441 10.1552 22.2369 8.90919L21.0452 8.69732V6.2861C21.0452 4.30096 19.2868 2.68606 17.1254 2.68606H16.9538V7.86577L1.36907 22.1781C0.486303 22.9888 0 24.0667 0 25.2133C0 25.8937 0.171158 26.5498 0.494837 27.1404L2.34766 25.4388L4.42842 27.3497ZM12.7267 15.3975H15.6692V18.1001H12.7267V15.3975Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorse);
export default __webpack_public_path__ + "static/media/logo-horse.509eac8431890c31c3a32936ef5ce949.svg";
export { ForwardRef as ReactComponent };